module.exports = __webpack_public_path__ + "static/media/workwear.b8e642be.svg";